import React from 'react';
import PropTypes from 'prop-types';
import RenderComponentProto from '../../../render-component-proto';

import UsersMultiselectPopoverMenu from "./popover/popover-menu";
import UsersMultiselectOptionPill from "./option-pill";

export default class UsersComponentProto extends RenderComponentProto {

    static propTypes = {
        id: PropTypes.string,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        width: PropTypes.number,

        canEdit: PropTypes.bool,

        onChange: PropTypes.func,
    }

    static defaultProps = {
        canEdit: false,
    }

    constructor(props) {
        super(props);

        this.state = {
            currentOptions: props.value,
            showPopover: false,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!_.isEqual(prevProps.value, this.props.value)) {
            this.setState({
                currentOptions: this.props.value,
            });
        }
    }

    showPopover = () => {
        if (this.props.canEdit && !this.state.showPopover)
            this.setState({showPopover: true})
    }

    hidePopover = () => {
        if (this.state.showPopover)
            this.setState({showPopover: false}, ()=>{
                if (this.props.onChange) this.props.onChange(this.state.currentOptions, this.onCancelChange);
            }
    )}

    onOptionClick = (option) => {
        let currentOptions = this.state.currentOptions ? this.state.currentOptions.slice() : [];
        this.previousOptions = currentOptions;
        currentOptions = gd.utils.toggleArrayValue(currentOptions, option.value);

        this.setState({
            currentOptions: currentOptions
        }, () => {
            if (!this.state.showPopover && this.props.onChange) this.props.onChange(currentOptions, this.onCancelChange);
        });
    }

    onCancelChange = () => {
        this.setState({
            currentOptions: this.previousOptions
        });
    }

    onDelete = (value) => this.onOptionClick({value})

    renderList() {
        const options = []
        _.map(gd.session.companyUsers.filterByCompany(gd.companyId).models, cu=>{
            if (cu?.user) {
                options.push({
                    value: cu.user.id,
                    label: cu.user.name,
                })
            }
        });

        let optionsToShow = _.get(this, 'state.currentOptions.length', 0);
        let moreOptions = 0;
        const pillMaxWidth = 115;
        const width = _.get(this, 'props.width', null);

        if (!_.isNil(width)) {
            optionsToShow = Math.floor(width/pillMaxWidth);
            moreOptions = _.get(this, 'state.currentOptions.length', 0) - optionsToShow;
        }

        const more = moreOptions > 0 ? <div className="ui5-link-small fl-ac m-l-5 h-20">{"{0}{1}".f(optionsToShow > 0 ? '+' : '', moreOptions)}</div> : null;

        return (
            <div className={Classes("fl-ac w-100-percent h-100-percent", this.props.className)} onClick={this.showPopover}>
                <div className="w-100-percent h-30 ui5-field-input-hover-border">
                    {_.map(this.state.currentOptions, (userId, key) => {
                        if (key >= optionsToShow) return;
                        return <UsersMultiselectOptionPill key={userId} style={{maxWidth: pillMaxWidth}} userId={userId} onDelete={this.onDelete}/>
                    })}
                    {more}

                    {this.state.showPopover && <UsersMultiselectPopoverMenu parent={this} options={options}/>}
                </div>
            </div>
        );
    }

    renderEdit() {
        const options = []
        _.map(gd.session.companyUsers.filterByCompany(gd.companyId).models, cu=>{
            if (cu?.user) {
                options.push({
                    value: cu.user.id,
                    label: cu.user.name,
                })
            }
        });

        const pillMaxWidth = 115;

        if (!this.state.currentOptions || this.state.currentOptions.length === 0) {
            return (
                <div className={Classes("gd-field-list-multi not-set", this.props.renderMode)} onClick={this.showPopover}>
                    <div className="field-holder">Please select</div>
                    {this.state.showPopover && <UsersMultiselectPopoverMenu parent={this} options={options}/>}
                </div>
            )
        } else {
            return (
                <div className={Classes("gd-field-list-multi", this.props.renderMode)} onClick={this.showPopover}>
                    <div className="fl-ac fl-wrap">
                        {_.map(this.state.currentOptions, (userId, key) => {
                            return <UsersMultiselectOptionPill key={userId} style={{maxWidth: pillMaxWidth}} userId={userId} onDelete={this.props.canEdit ? this.onDelete : null}/>
                        })}
                    </div>

                    {this.state.showPopover && <UsersMultiselectPopoverMenu parent={this} options={options}/>}
                </div>
            )
        }
    }

    render() {
        let res = null;
        switch (this.props.renderMode) {
            case 'list'     : res = this.renderList(); break;

            case 'edit'     :
            case 'view'     :
            case 'form-new' : res = this.renderEdit(); break;
        }

        return res;
    }
}